import { get } from './client';

export const getHealth = () => get('/api/health');
